import React, { useEffect, useState } from 'react';
import Modal from '../ui/Modal';
import { useToast } from '../../hooks/useToast';
import { reopenQuestionnaire } from '../../api/questionnaire';

const ReopenQuestionnaireModal = ({ isOpen, leadId, onClose, onRefresh }) => {
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isOpen) {
      setError(null);
      setLoading(false);
    }
  }, [isOpen]);

  const handleReopen = async () => {
    setLoading(true);
    setError(null);
    try {
      await reopenQuestionnaire(leadId);
      toast.success('Questionnaire reopened.');
      onRefresh && onRefresh();
      onClose();
    } catch (err) {
      const msg = err.response?.data?.detail?.error?.message
        || err.response?.data?.detail
        || err.message
        || 'Failed to reopen questionnaire';
      const errorMsg = typeof msg === 'string' ? msg : JSON.stringify(msg);
      setError(errorMsg);
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Reopen Questionnaire"
      size="md"
      closeOnOverlayClick={!loading}
      showCloseButton={!loading}
      footer={
        <>
          <button
            onClick={handleClose}
            disabled={loading}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={handleReopen}
            disabled={loading}
            className="px-4 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary-600 transition disabled:opacity-50 flex items-center gap-2"
          >
            {loading && (
              <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
              </svg>
            )}
            {loading ? 'Reopening...' : 'Reopen'}
          </button>
        </>
      }
    >
      <p className="text-gray-700">
        Are you sure you want to reopen this questionnaire? The questionnaire will be set back to
        in-progress and can be edited again.
      </p>
      {error && (
        <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-xs text-red-800">{error}</p>
        </div>
      )}
    </Modal>
  );
};

export default ReopenQuestionnaireModal;
